import { useEffect } from "react";
import appLocales from "./appLocales";
import useMessages from "./useMessages";
import { useUpdate } from "react-use";

function useLocalizeMessages({locale = appLocales.PT_BR, context, config}) {
  const { localize } = useMessages();
  const update = useUpdate();

  useEffect(() => {
    localize(locale, context, config);
    update();
  }, [locale, context]); 

  return (null);
}

export default useLocalizeMessages;
